<template src="../templates/contactDetails.html"></template>
<script>
    import ContactModel from "../models/contactModel";

    export default {
        name: 'Contact',
        data() {
            return {
                contactModel: {},
                dialogFormVisible: false,
                parent_client_id: localStorage.getItem("parent_client_id")
            }
        },
        methods: {
            loadDetails: function () {
                this.contactModel = new ContactModel();
                let url = this.$localApiURL + this.contactModel.getRoute("fetch");
                this.contactModel.fetch({
                    'url': url,
                    params: {token: localStorage.getItem('jwt')}
                }).then().catch((error) => {
                    console.error(error);
                });
            },
            editContactInfo() {
                this.dialogFormVisible = true;
            }
        }, created: function () {
            this.loadDetails();
        },

    }
</script>

<style>
    .row-bg {
        border: 1px solid rgba(0, 0, 0, 0.125);
        text-align: left;
        align-items: center;
    }

    .el-card__body {
        padding: 0px;
    }

    .content_label {
        color: black !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/ContactComponent.vue